import { render, staticRenderFns } from "./ChevronDoubleDown.vue?vue&type=template&id=023f8b52"
import script from "./ChevronDoubleDown.vue?vue&type=script&lang=js"
export * from "./ChevronDoubleDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports